import React from 'react'
import './Services.css'
import {BiCheck} from 'react-icons/bi'

const Services = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>
      <div className="container services__container">
        <article className="service">
        <div className='service__head'>
          <h3>Web Design</h3>
        </div>
        <ul className='service__list'>
        <li>
          <BiCheck className='service__list__icon'/>
          <p>Basic WebDevelopment services</p>
        </li>
        <li>
          <BiCheck className='service__list__icon'/>
          <p>Javascript Develper</p>
        </li>
        <li>
          <BiCheck className='service__list__icon'/>
          <p>Web Design with Figma</p>
        </li>
        <li>
          <BiCheck className='service__list__icon'/>
          <p>Respnsive web Design</p>
        </li>
        <li>
          <BiCheck className='service__list__icon'/>
          <p>React Js Development</p>
        </li>
        <li>
          <BiCheck className='service__list__icon'/>
          <p>Web 3d animation with Spline.</p>
        </li>
       
        </ul>
        </article>
        {/* END OF WEB DEV */}
        <article className="service">
        <div className='service__head'>
          <h3>CyberSecurity</h3>
        </div>
        <ul className='service__list'>
        <li>
          <BiCheck className='service__list__icon'/>
          <p>Computer Networking and Troubleshooting.</p>
        </li>
        <li>
          <BiCheck className='service__list__icon'/>
          <p>Network Defense and Security</p>
        </li>
        <li>
          <BiCheck className='service__list__icon'/>
          <p>Computer Network security advice.</p>
        </li>
       
        </ul>
        </article>
        {/* END of CyberSecurity */}
        <article className="service">
        <div className='service__head'>
          <h3>Other Skills</h3>
        </div>
        <ul className='service__list'>
        <li>
          <BiCheck className='service__list__icon'/>
          <p>Python Developer</p>
        </li>
        <li>
          <BiCheck className='service__list__icon'/>
          <p>Embedded systems developer</p>
        </li>
        <li>
          <BiCheck className='service__list__icon'/>
          <p>Computer Software Development</p>
        </li>
        </ul>
        </article>
        {/* END OF CONTENT CREATION */}
      </div>
    </section>
  )
}

export default Services